var _a;
import { certStatus, prjStatus, vendorSubPrjStatus } from '../config/BVConstants';
export const certStatusOptions = certStatus.map((item) => ({
    label: item === null || item === void 0 ? void 0 : item.strLongDesc, // Use a descriptive label from your data
    value: String(item === null || item === void 0 ? void 0 : item.intId), // Convert intId to a string value (optional)
}));
export const prjStatusOptions = prjStatus.map((item) => ({
    label: item === null || item === void 0 ? void 0 : item.strLongDesc, // Use a descriptive label from your data
    value: String(item === null || item === void 0 ? void 0 : item.intId), // Convert intId to a string value (optional)
}));
export const subPrjStatusOptions = (_a = vendorSubPrjStatus.filter((item) => ![4010, 4020, 4006].includes(item === null || item === void 0 ? void 0 : item.intId))) === null || _a === void 0 ? void 0 : _a.map((item) => ({
    label: item === null || item === void 0 ? void 0 : item.strLongDesc, // Use a descriptive label from your data
    value: String(item === null || item === void 0 ? void 0 : item.intId), // Convert intId to a string value (optional)
}));
export const regLibStatusOptions = certStatus.map((item) => ({
    label: item === null || item === void 0 ? void 0 : item.strLongDesc,
    value: String(item === null || item === void 0 ? void 0 : item.intId),
}));
